// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonActions = {
  all: "すべて",
  save: "保存",
  restoreDefault: "既定値に戻す",
  cancel: "キャンセル",
  confirm: "確認",
  view: "表示",
  edit: "編集",
  back: "戻る",
  close: "閉じる",
  logout: "ログアウト",
  changePassword: "パスワード変更",
  exitImpersonation: "代理操作を終了",
  add: "追加",
  create: "作成",
  upload: "アップロード",
  import: "インポート",
  delete: "削除",
  destroy: "破棄",
  confirmDelete: "削除を確認",
  publish: "公開",
  preview: "プレビュー",
  viewDetail: "表示",
  saveChanges: "変更を保存",
  updatePassword: "パスワードを更新",
  search: "検索",
  reset: "リセット",
  prevStep: "前のステップ",
  nextStep: "次のステップ",
  viewAll: "すべて表示",
  viewLoginOnly: "ログインログのみ",
  run: "実行",
  stop: "停止",
  share: "共有",
  copy: "コピー",
  download: "ダウンロード",
  archive: "アーカイブ",
  restore: "復元",
  enable: "有効化",
  disable: "無効化",
  retry: "再試行",
  generate: "生成",
  configure: "設定",
  commit: "コミット",
  compare: "比較",
  resetPassword: "パスワードをリセット",
  unlock: "ロック解除",
  lock: "ロック",
  extend: "延長",
  refresh: "更新",
  enter: "移動",
  open: "開く",
  more: "その他",
  select: "選択",
  clear: "クリア",
  filtered: "絞り込み済み",
  selectFile: "ファイルを選択",
  selectCurrentPage: "全選択",
  selectAcrossPagesMax: "ページ横断で全選択",
  clearSelection: "選択を解除",
  batchActions: "一括操作",
} as const;

export const commonSemanticActionLabels = {
  destroy: commonActions.destroy,
  generate: commonActions.generate,
  configure: commonActions.configure,
  commit: commonActions.commit,
  compare: commonActions.compare,
  resetPassword: commonActions.resetPassword,
  unlock: commonActions.unlock,
  lock: commonActions.lock,
  extend: commonActions.extend,
} as const;
